import { TeacherCourseSectionEnrollment } from "../../../Utilities";
import * as ModelUtilities from "../_General";

export function isActive(
	enrollment: Pick<TeacherCourseSectionEnrollment, "lateStartDate" | "earlyEndDate">,
	date?: Date,
) {
	return ModelUtilities.isEnrollmentActive(enrollment, date);
}
